import React from 'react';

import { setColorDatabase } from '../redux/actions/BikeActions';
import { connect } from 'react-redux';
import classnames from 'classnames';

// Set color depends on render index and color index

class Colors extends React.PureComponent {

    changeColor = event => {
        const { bike } = this.props;
        this.props.dispatch(setColorDatabase(event, bike));
    }

    render() {
        return (
            <div className="colors">
                <div className="category-head">
                    <p>3. Choose Color</p>
                </div>
                {/* Map all colors and set current color and color index to data attr */}
                <div className="colors-container">
                    {this.props.bike.colors.map((color, index) => {
                            const cn = classnames('color', {
                                active: index === 0,
                                [color]: color
                            })
                            return <button 
                                    className={cn} 
                                    key={color} 
                                    onClick={this.changeColor} 
                                    data-color={color} 
                                    data-index={index} 
                                />
                        })
                    }                
                </div>
            </div>
        )
    }
}

// REDUX STATES
const mapStateToProps = state => {
    return {
        bike: state.bike.bike
    }
};

export default connect(mapStateToProps)(Colors);


// WEBPACK FOOTER //
// ./src/components/Colors.js